import { createContext } from "react"
import { LoginForm } from "../../../types/global/UserAuthTypes";

export type UserAuthContextProps = {
  login: (form: LoginForm) => void
  logout: () => void
}

export const UserAuthContext = createContext<UserAuthContextProps>(null!);